module.exports = __webpack_public_path__ + "static/media/transparent.06a92736.svg";